<template>
  <div class="w-100" v-if="listItemsTotals">
    <small class="" v-for="(item, i) in listItemsTotals" :key="i">
      <Tooltip :text="item.tooltip" :width="'auto'">
        <span>
          <img
            class="ml-1 d-inline"
            :src="require('@/assets/images/' + item.icon)"
            alt=""
            srcset=""
            width="13px"
          />
          <span v-if="loadingStats" class="mx-2 p-0">
            <Loadingcircle :paramloading="paramloading" />
          </span>
          <span v-else class="mx-2"> {{ item.value }} </span>
        </span>
      </Tooltip>
    </small>
  </div>
</template>

<script>
import Vue from "vue";
import { targetsService, usersService } from "@/_services";
import ItemMonitor from "@/components/Dashboard/Monitor/row.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import Loadingcircle from "@/components/Common/Loadingcircle.vue";
export default {
  data() {
    return {
      paramloading: {
        width: "18px",
        height: "18px",
        color: "#5054EB",
      },
      loadingStats: true,
      totals: {
        sent_emails: 0,
        meetings: 0,
        contacts_days: 0,
        meeting_rate: 0,
      },
      listItemsTotals: [
        {
          label: this.$t("lang.column.total_meetings_short"),
          value: 0,
          class: "badge badge-success text-light",
          link: null,
          icon: "icon_contacts.png",
          name: "contacts",
          tooltip: "Unique prospects",
        },
        {
          label: this.$t("lang.column.total_meetings_short"),
          value: 0,
          class: "badge badge-success text-light",
          link: null,
          icon: "icon_sent-mail.png",
          name: "email_sent",
          tooltip: "Sent emails",
        },
        {
          label: this.$t("lang.column.conversion_rate_short"),
          value: 0,
          class: "badge badge-success text-light",
          link: null,
          icon: "icon_bar-chart.png",
          name: "convertion_rate",
          tooltip: "Meetings / Unique prospects",
        },
        {
          label: this.$t("lang.column.total_meetings_short"),
          value: 0,
          class: "badge badge-success text-light",
          link: null,
          icon: "icon_agenda.png",
          name: "meetings",
          tooltip: "Meetings",
        },
        {
          label: this.$t("lang.column.avg_new_contact_day_short"),
          value: 0,
          class: "badge badge-success text-light",
          link: null,
          icon: "icon_coin.png",
          name: "amount",
          tooltip: "Spent",
        },
      ],
      campaigns: [],
      total: 0,
    };
  },

  props: {
    orderId: String,
    qty: {
      type: Boolean,
      default: false,
    },
    stats: Object,
    labels: String,
  },

  components: { ItemMonitor, Tooltip, Loadingcircle },

  created() {
    this.getStats();
  },

  watch: {
    stats: {
      handler() {
        this.loadingStats = true;
        this.getStats();
      },
      deep: true,
    },
    orderId() {
      this.loadingStats = true;
      this.getStats();
    },
  },

  methods: {
    getStats() {
      if (!this.stats) {
        this.loadingStats = false;
        return;
      }

      this.listItemsTotals.find((e) => e.name === "meetings").value =
        this.stats["total_meetings"] || 0;
      this.listItemsTotals.find((e) => e.name === "convertion_rate").value =
        this.stats["meeting_rate"] || 0;
      this.listItemsTotals.find((e) => e.name === "email_sent").value =
        this.stats["total_email_sent"] || 0;
      this.listItemsTotals.find((e) => e.name === "contacts").value =
        this.stats["total_contacted_contacts"] || 0;

      const amountItem = this.listItemsTotals.find((e) => e.name === "amount");
      if (this.stats["total_amount"]) {
        amountItem.value = parseInt(this.stats["total_amount"]).toFixed(2);
      } else {
        amountItem.value = 0;
      }

      this.loadingStats = false;
    },
    // getStats() {
    //   targetsService
    //     .getStats(this.orderId)
    //     .then((res) => {
    //       this.listItemsTotals.find((e) => e.name === "meetings").value =
    //         res.total_meetings;
    //       this.listItemsTotals.find((e) => e.name === "convertion_rate").value =
    //         res.conversion_rate;
    //       this.listItemsTotals.find((e) => e.name === "email_sent").value =
    //         res.total_email_sent;
    //       this.listItemsTotals.find((e) => e.name === "contacts").value =
    //         res.total_contacts;

    //       if (res.amount) {
    //         const amount = parseInt(res.amount).toFixed(2);
    //         this.listItemsTotals.find((e) => e.name === "amount").value =
    //           amount;
    //       }

    //       this.loadingStats = false;
    //     })
    //     .catch((err) => console.log(err));
    // },
  },
};
</script>
